// 抽取 已发布/待发布/添加榜单列表

import ZtDialog from '@cps/ZtDialog'
import ZtFormItem from '@cps/ZtFormItem'
import ZtTitle from '@cps/ZtTitle'
import SpriteIcon from '@cps/SpriteIcon'
import dialogLink from '../components/dialogLink'
import radioChecked from '../components/radioChecked'
import { formatEmpty, formatSource, formatRatio, formatPercentum } from '../filters'

// 天转毫秒
function day2ms(day) {
  return day * 24 * 60 * 60 * 1000
}

const datePickerOpt = {
  disabledDate(time) {
    return time.getTime() > new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1
  },
  shortcuts: [
    {
      text: '一周前',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - day2ms(7))
        picker.$emit('pick', [date, new Date()])
      },
    },
    {
      text: '一月前',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - day2ms(30))
        picker.$emit('pick', [date, new Date()])
      },
    },
    {
      text: '三月前',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - day2ms(90))
        picker.$emit('pick', [date, new Date()])
      },
    },
    {
      text: '一年前',
      onClick(picker) {
        const date = new Date()
        date.setTime(date.getTime() - day2ms(365))
        picker.$emit('pick', [date, new Date()])
      },
    },
  ],
}


export default {
  components: {
    ZtDialog,
    ZtTitle,
    dialogLink,
    radioChecked,
    SpriteIcon,
    ZtFormItem,
  },
  filters: {
    formatEmpty,         // 格式化空数据
    formatSource,        // 格式化来源
    formatRatio,         // 格式化百分比
    formatPercentum,
  },
  watch: {
    fromModel(val) {
      this.seeker.from = val.join(',')
    },
    timeModel(val) {
      this.seeker.add_time_from = val && val.length ? val[0] : '';
      this.seeker.add_time_to = val && val.length ? val[1] : '';
    },
    'seeker.channel'(channel) {
      if(channel == 1 || channel == 3) {
        this.orderTypeModel = ''     // 排序类型
        this.orderModel= ''             // 顺序
      }
      else
      {
        this.orderTypeModel = 'add_time'     // 排序类型
        this.orderModel= 'DESC'             // 顺序
      }

    },
  },
  data: () => ({
    // ---------------------- table ----------------------
    table: [],
    tableSelected: [],
    tableSelectedID: [],
    tableSelectedItemID: [],
    tableLoading: false,


    // ---------------------- 检索器 ----------------------
    seeker: {
      title: '',
      item_id: '',
      channel:'',              // 频道
      from: '',                // 来源
      type: '',                // 类型
      select: '',              // 筛选
      item_brand: '',          // 品牌
      item_iid: '',            // 淘宝id
      order: '',
      max_commission_rate_from: '',   // 优惠券起始区间
    },
    fromModel: [''],                // 来源
    typeModel: [],                  // 类型
    orderTypeModel: 'add_time',     // 排序类型
    orderModel: 'DESC',             // 顺序
    timeModel: '',                  // 时间范围
    datePickerOpt,                  // 日期选择器配置


    // ---------------------- 分页器 ----------------------
    page: 1,
    pagesize: 10,
    recordcount: 10,


    // ---------------------- dialog Data ----------------------
    dialogLinkVisible: false,       // 添加链接可见
  }),
  methods: {

    // ---------------------- 分页器 ----------------------
    // 切换页面大小
    onPageSizeChange(pagesize) {
      this.pagesize = pagesize;
      this.getList();
    },
    // 切换页面
    onPageChange(page) {
      this.page = page;
      this.getList();
    },

    // ---------------------- 检索器 ----------------------
    // 搜索
    onSeeker() {
      this.page = 1;
      this.getList()
    },
    // 改变排序 - 类型
    changeOrderType(e) {
      if(e) {
        if(!this.orderModel)
          this.orderModel = 'DESC'
      }else{
        this.orderModel = '',
        this.orderTypeModel = ''
      }
    },
    // 改变排序 - 顺序
    changeOrder(e) {
      if(e) {
        if(!this.orderTypeModel)
          this.orderTypeModel = 'add_time'
      }else{
        this.orderModel = '',
        this.orderTypeModel = ''
      }
    },
    // 转换检索类型 [淘抢购,聚划算,金牌商家,天猫商城,运费险,视频]
    toSeekerType(arr) {
      var obj = {};
      arr.forEach((key) => {
        obj[key] = 1;
      })
      return obj
    },
    toSeekerOrder() {
      return [this.orderTypeModel, this.orderModel].join(' ').replace(/(^\s*)|(\s*$)/g, '')
    },
    // 选择时间
    changeTime() {
      this.getList();
    },


    // ---------------------- 表格 ----------------------
    // table选择器
    onSelectionChange(e) {
      this.tableSelected = e
      this.tableSelectedID = e.map((item) => item.id)
      this.tableSelectedItemID = e.map((item) => item.item_id)
    },


    // ---------------------- 操作 ----------------------
    // 删除多件商品
    onDel() {
      const id = this.tableSelectedID
      this.sbtDel(id);
    },

    // ---------------------- tool ----------------------
    // 频道 转 cn
    channel2cn(channel, item_price) {
      if(!channel && !item_price) return
      if (channel.length && channel[0].channel_id == 1) {
        return '人工精选'
      }else if(new Number(item_price) <= 29.9) {
        return '九块九'
      }else {
        return '无'
      }
    },
  },

}
